<template>
    <div class="price_box">
        <div class="header">
            <p class="balance">
                <span>累计赔付金额</span>
                <span class="list"
                      @click="toPage('/vip/balanceRecord')">余额记录</span>
            </p>
            <p class="bal_money">
                {{ money }} <span class="dw">元</span>
                <span class="withDraw"
                      @click="toRedirect"><span class="font">提现</span></span>
            </p>
        </div>
        <div v-if="list.length > 0">
            <div class="pro_item">
                <h1 class="h1"><span class="line"></span> 现金券</h1>
            </div>
            <div class="record_item">
                <div class="item"
                     v-for="(item, index) in list"
                     :key="index"
                     :class="{ opacity: item.used == true }">
                    <div class="info">
                        <p class="title">拒就赔现金券</p>
                        <p class="time">贷款被拒后自动兑换至余额</p>
                    </div>
                    <div class="money">
                        <span class="red">{{ item.denomination }}</span>
                        <span class="redDw">元</span>
                        <span v-if="item.used == true"
                              class="allUse_icon"></span>
                    </div>
                </div>
            </div>
        </div>
        <div v-else
             class="mescroll-empty">
            <p class="empty-tip">暂无相关数据~</p>
        </div>
        <div class="shadow"
             v-if="isShowToast || isShowMoneyToast"></div>
        <div class="toast"
             v-if="isShowToast">
            <img @click="toUrl"
                 :src="toastJson.imageUrl"
                 alt=""/>
            <span class="clost_btn"
                  @click="toHide"></span>
        </div>
        <div class="toast bg"
             v-if="isShowMoneyToast">
      <span class="money_bg1"
            v-if="os==1"></span>
            <span class="money_bg1"
                  v-if="os==2"></span>
            <span class="close_btn"
                  @click="toHide"></span>
            <p class="toast_title">申请提现</p>
            <div class="toast_con">
                提现金额已发放至<span class="red">{{tips1}}</span>的账户余额，下载<span class="red">{{tips2}}</span>即可提现
            </div>
            <span class="btn"
                  @click="toDownload">去下载提现</span>
        </div>
    </div>
</template>

<script>
    export default {
        components: {},
        data() {
            return {
                list: [],
                money: "",
                toastJson: {},
                isShowToast: 0,
                isShowMoneyToast: 0,
                tips1: '',
                tips2: '',
                os: localStorage.getItem("os"),
                packageName: localStorage.getItem("packageName"),
                appVersion: localStorage.getItem("appVersion"),
            };
        },
        mounted() {
            this.util.title("我的钱包");
            this.getList();
            this.getAdver();
            if (this.os == 1) {
                this.tips1 = '互赚宝';
                this.tips2 = '互赚宝APP';
            } else if (this.os == 2) {
                this.tips1 = '互赚宝';
                this.tips2 = '互赚宝APP';
            }
        },
        methods: {
            toDownload() {
                let p = localStorage.getItem("os");
                console.log(p);
                if (p == 1) {
                    window.location.href =
                        "http://yizhuanbao-prod-app.yanhugame.com/package/android/makemoney_fapp.apk";
                } else if (p == 2) {
                    window.location.href =
                        "itms-services://?action=download-manifest&url=https://yizhuanbao-prod-app.yanhugame.com/package/ios/ios.plist";
                    //"https://apps.apple.com/cn/app/%E5%AE%89%E5%BF%83%E5%85%BC%E8%81%8C-%E6%89%8B%E6%9C%BA%E5%85%BC%E8%81%8C%E8%B5%9A%E9%92%B1%E5%B9%B3%E5%8F%B0/id1543868948";
                }
            },
            toShowMoneyToast() {
                this.isShowMoneyToast = 1;
            },
            toRedirect() {
                let param = {
                    key: "withdraw_redirect_config"
                }
                this.$get('/app/api/v1/config/getValue', param)
                    .then(res => {
                        var e = res;
                        if (e.code == 200) {
                            this.isBind = e.data.isBind;
                            this.allMoney = e.data.account;
                            this.applyNum = e.data.applyNum;
                            /*let packageName = this.packageName;
                            let appVersion = this.appVersion;*/
                            if (e.data == 0) {
                                this.toShowMoneyToast();
                            } else if (e.data == 1) {  //支付宝提现
                                this.$router.push({
                                    path: "/vip/applyWithDral?payType=0"
                                })
                            } else if (e.data == 2) {  //微信提现
                                this.$router.push({
                                    path: "/vip/applyWithDral?payType=1"
                                })
                                /*if (packageName == "com.pcl.creditsuper" && appVersion >= '1.5.1') {
                                    this.$router.push({
                                        path: "/vip/applyWithDral?payType=1"
                                    })
                                } else if (packageName == "com.qw.xiaoesujie" && appVersion >= '1.5.1') {
                                    this.$router.push({
                                        path: "/vip/applyWithDral?payType=1"
                                    })
                                } else if (packageName == "com.dkcs.ios.dkcs" && appVersion >= '1.5.0') {
                                    this.$router.push({
                                        path: "/vip/applyWithDral?payType=1"
                                    })
                                } else if (packageName == "com.tcb.TCHelp" && appVersion >= '1.0.0') {
                                    this.$router.push({
                                        path: "/vip/applyWithDral?payType=1"
                                    })
                                } else {
                                    this.toShowMoneyToast();
                                }*/
                            } else {
                                this.toShowMoneyToast();
                            }
                        } else {
                            this.util.toast({msg: e.message})
                        }
                    })
                    .catch(error => {
                    });
            },
            toUrl() {
                let json = {
                    event_key: "h5_vip_center_ad_click",
                };
                this.toCountPoint(json);
                window.location.href = this.toastJson.pageUrl;
            },
            //统计埋点
            toCountPoint(json, pageUrl) {
                this.$get("/app/api/v1/newEventTrace", json)
                    .then((res) => {
                        if (res.code == 200) {
                        } else {
                            this.util.toast({msg: res.message});
                        }
                    })
                    .catch((error) => {
                    });
            },
            getAdver() {
                let _this = this;
                this.$get("/app/api/v1/ad/loanPage", {type: 17})
                    .then((res) => {
                        if (res.code == 200) {
                            if (res.data) {
                                _this.toastJson = res.data;
                                _this.isShowToast = 1;
                            } else {
                                _this.isShowToast = 0;
                            }
                        } else {
                            this.util.toast({msg: res.message});
                        }
                    })
                    .catch((error) => {
                    });
            },
            toHide() {
                this.isShowToast = 0;
                this.isShowMoneyToast = 0;
            },
            getList() {
                //绑定银行卡
                let _this = this;
                this.$get("/app/v1.0/memeber/getCouponsByCustomerId")
                    .then((res) => {
                        var e = res;
                        if (e.code == 200) {
                            _this.list = e.data.coupons;
                            _this.money = e.data.money;
                        } else {
                            _this.util.toast({msg: e.msg});
                        }
                    })
                    .catch((error) => {
                    });
            },
            toPage(path) {
                // 进入监测页面
                this.$router.push({
                    path: path,
                    query: {
                        money: this.money,
                    },
                });
            },
        },
    };
</script>
<style scoped>
    .price_box {
        font-family: PingFangSC-Regular;
        background: #f7f7f7;
        padding: 0.15rem;
        position: relative;
        top: 0.01rem;
    }

    .h1 {
        font-size: 0.14rem;
        color: #333;
    }

    .line {
        display: inline-block;
        width: 3px;
        height: 0.12rem;
        background: linear-gradient(
                135deg,
                rgba(255, 172, 85, 1) 0%,
                rgba(255, 57, 31, 1) 100%
        );
        box-shadow: 0px 4px 10px 0px rgba(255, 191, 128, 0.2);
        border-radius: 4px;
        margin-right: 0.05rem;
    }

    .list {
        float: right;
        border: 1px solid #fff;
        width: 0.8rem;
        height: 0.3rem;
        text-align: center;
        line-height: 0.3rem;
        border-radius: 15px;
        position: relative;
        top: -0.06rem;
        z-index: 11;
    }

    .withDraw {
        font-size: 0.12rem;
        display: inline-block;
        width: 0.8rem;
        height: 0.3rem;
        background: #fff;
        border-radius: 15px;
        text-align: center;
        line-height: 0.3rem;
        position: absolute;
        right: 0;
        top: 0.25rem;
        z-index: 1;
    }

    .font {
        font-family: PingFangSC-Medium;
        font-weight: 500;
        color: rgba(255, 255, 255, 1);
        line-height: 12px;
        background: linear-gradient(
                180deg,
                rgba(255, 135, 76, 1) 0%,
                rgba(248, 75, 69, 1) 100%
        );
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
    }

    .allUse_icon {
        display: inline-block;
        width: 0.73rem;
        height: 0.73rem;
        background: url('../../assets/img/vip/allUse.png') no-repeat top center;
        background-size: 100% 100%;
        margin: 0 auto;
        border-radius: 50%;
        position: absolute;
        left: 50%;
        transform: translate(-50%, 0);
        z-index: 2;
        background-color: rgba(247, 243, 241, 0.4);
    }

    .header {
        width: 100%;
        height: 1.06rem;
        background: linear-gradient(
                135deg,
                rgba(255, 172, 85, 1) 0%,
                rgba(255, 57, 31, 1) 100%
        );
        box-shadow: 0px 4px 10px 0px rgba(255, 191, 128, 0.2);
        border-radius: 4px;
        margin: 0 auto;
        padding: 0.24rem 0.15rem 0.22rem 0.15rem;
        margin-bottom: 0.2rem;
    }

    .bal_money {
        font-family: DINAlternate-Bold;
        font-size: 0.4rem;
        color: #fff;
        position: relative;
        top: -0.06rem;
    }

    .balance {
        color: #fff;
        font-size: 0.12rem;
    }

    .dw {
        font-size: 0.14rem;
        top: -0.03rem;
        font-size: 0.14rem;
        position: relative;
        left: -0.06rem;
    }

    .item {
        display: flex;
        flex: 1;
        justify-content: space-between;
        font-size: 0.14rem;
        height: 1.13rem;
        margin-bottom: 0.15rem;
        /* background: rgba(255, 255, 255, 1); */
        background: url('../../assets/img/vip/money_bg.png') no-repeat center center;
        background-size: 100% 100%;
        box-shadow: 0px 2px 6px 0px rgba(210, 210, 210, 0.5);
        padding: 0.35rem 0rem 0.36rem 0.15rem;
        position: relative;
    }

    .item .title {
        color: #333;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: rgba(51, 51, 51, 1);
    }

    .item .time {
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(153, 153, 153, 1);
        margin-top: 0.04rem;
    }

    .info {
        flex: 0.67;
    }

    .money {
        flex: 0.33;
        position: relative;
        top: -0.05rem;
        text-align: center;
    }

    .item .gray {
        color: #666;
        font-size: 0.26rem;
        margin-right: 0.03rem;
    }

    .item .red {
        margin-right: 0.03rem;
        font-size: 0.34rem;
        font-family: DINAlternate-Bold, DINAlternate;
        font-weight: bold;
        color: rgba(255, 81, 74, 1);
    }

    .redDw {
        font-size: 0.14rem;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(255, 81, 74, 1);
    }

    .grayDw {
        color: #666;
        font-size: 0.14rem;
    }

    .opacity {
        opacity: 0.4;
    }

    .mescroll-empty {
        padding-top: 0.1rem;
        text-align: center;
    }

    .empty-tip {
        margin-top: 6px;
        font-size: 14px;
        color: gray;
    }

    .record_item {
        padding-top: 0.15rem;
    }

    .shadow {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100vh;
        background: rgba(0, 0, 0, 1);
        opacity: 0.4;
        z-index: 11;
    }

    .toast {
        position: absolute;
        z-index: 111;
        top: 0.72rem;
        left: 50%;
        transform: translate(-50%, 0);
        text-align: center;
    }

    .clost_btn {
        display: inline-block;
        width: 0.32rem;
        height: 0.32rem;
        background: url('../../assets/img/vip/vip_toast_closeBtn.png') no-repeat top center;
        background-size: 100% 100%;
        margin-top: 0.22rem;
    }

    .toast img {
        width: 3.15rem;
        margin: 0 auto;
    }

    .bg {
        background: #fff;
        width: 2.95rem;
        border-radius: 10px;
        text-align: center;
        padding: 0.34rem 0.25rem 0.3rem;
        top: 1.1rem;
    }

    .money_bg1 {
        background: url('../../assets/img/vip/money_bg1.png') no-repeat center center;
        background-size: 100% 100%;
        width: 1.96rem;
        height: 1.11rem;
        display: inline-block;
        margin-bottom: 0.2rem;
    }

    .money_bg2 {
        background: url('../../assets/img/vip/money_bg2.png') no-repeat center center;
        background-size: 100% 100%;
        width: 1.96rem;
        height: 1.11rem;
        display: inline-block;
        margin-bottom: 0.2rem;
    }

    .close_btn {
        background: url('../../assets/img/vip/close_btn_mon.png') no-repeat center center;
        background-size: 100% 100%;
        width: 0.16rem;
        height: 0.16rem;
        display: inline-block;
        position: absolute;
        right: 0.2rem;
        top: 0.2rem;
    }

    .toast_title {
        font-size: 0.2rem;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: rgba(0, 0, 0, 1);
    }

    .toast_con {
        font-size: 0.16rem;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(0, 0, 0, 1);
        margin-top: 0.11rem;
        margin-bottom: 0.3rem;
        line-height: 31px;
    }

    .red {
        font-weight: 400;
        color: rgba(255, 81, 74, 1);
    }

    .btn {
        display: block;
        text-align: center;
        width: 2.45rem;
        background: linear-gradient(
                135deg,
                rgba(255, 172, 85, 1) 0%,
                rgba(255, 57, 31, 1) 100%
        );
        box-shadow: 0px 4px 10px 0px rgba(255, 191, 128, 0.2);
        border-radius: 25px;
        font-size: 0.17rem;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: rgba(255, 255, 255, 1);
        padding: 0.12rem 0;
    }
</style>
